"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HttpWrapper_1 = __importDefault(require("./http/HttpWrapper"));
var Deferred_1 = __importDefault(require("./Deferred"));
var AUTH_FRAME_ID = 'authFrame';
var AUTH_RESPONSE_TIMEOUT = 15000;
var ClientAuth = /** @class */ (function () {
    function ClientAuth(authServiceUrl) {
        this.authServiceUrl = authServiceUrl.replace(/^\/|\/$/g, '');
    }
    ClientAuth.prototype.getAuthTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deferred, listener, authUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deferred = new Deferred_1.default();
                        listener = this.createEventListener(deferred.resolve);
                        this.subscribeToMessageEvents(listener);
                        authUrl = "".concat(this.authServiceUrl, "/authtoken?origin=").concat(window.location.origin);
                        this.initAuthFrame(authUrl);
                        this.setResponseTimeout(deferred.reject);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, deferred.promise];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [2 /*return*/, null];
                    case 4:
                        this.disposeAuthFrame();
                        this.unsubscribeFromMessageEvents(listener);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ClientAuth.prototype.getTokenSet = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authUrl, tokens, result_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authUrl = "".concat(this.authServiceUrl, "/api/v1/auth/token?origin=").concat(window.location.origin);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, HttpWrapper_1.default.get(authUrl, {
                                fetchOptions: {
                                    credentials: 'include'
                                }
                            })];
                    case 2:
                        tokens = _a.sent();
                        result_1 = {};
                        tokens.forEach(function (_a) {
                            var endpoint = _a.endpoint, token = _a.token;
                            result_1[endpoint] = token;
                        });
                        return [2 /*return*/, result_1];
                    case 3:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ClientAuth.prototype.getToken = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            var authUrl, token, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authUrl = "".concat(this.authServiceUrl, "/api/account/token?clientId=").concat(clientId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, HttpWrapper_1.default.get(authUrl, {
                                fetchOptions: {
                                    credentials: 'include'
                                }
                            })];
                    case 2:
                        token = (_a.sent()).token;
                        return [2 /*return*/, token];
                    case 3:
                        e_3 = _a.sent();
                        console.error(e_3);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ClientAuth.prototype.initAuthFrame = function (src) {
        var frame = document.createElement('iframe');
        frame.setAttribute('style', 'display:none;');
        frame.setAttribute('src', src);
        frame.setAttribute('id', AUTH_FRAME_ID);
        document.body.appendChild(frame);
    };
    ClientAuth.prototype.disposeAuthFrame = function () {
        var frame = document.getElementById(AUTH_FRAME_ID);
        if (frame) {
            frame.parentNode.removeChild(frame);
        }
    };
    ClientAuth.prototype.setResponseTimeout = function (reject) {
        var _this = this;
        setTimeout(function () {
            return reject("Timeout error: auth server (".concat(_this.authServiceUrl, ") did not respond within ").concat(AUTH_RESPONSE_TIMEOUT, "ms."));
        }, AUTH_RESPONSE_TIMEOUT);
    };
    ClientAuth.prototype.subscribeToMessageEvents = function (handler) {
        window.addEventListener('message', handler);
    };
    ClientAuth.prototype.unsubscribeFromMessageEvents = function (handler) {
        window.removeEventListener('message', handler);
    };
    ClientAuth.prototype.createEventListener = function (resolve) {
        var _this = this;
        return function (event) { return _this.tokensHandler(event, resolve); };
    };
    ClientAuth.prototype.tokensHandler = function (event, resolve) {
        if (!this.isValidEvent(event)) {
            return;
        }
        resolve(event.data.tokens);
    };
    ClientAuth.prototype.isValidEvent = function (event) {
        return event.origin === this.authServiceUrl && event.data && event.data.tokens;
    };
    return ClientAuth;
}());
exports.default = ClientAuth;
